import { useCallback } from 'react';

// v7 owc-select-dropdown pulls focus back to its own combobox whenever a slotted child is focused,
// which makes the custom search field impossible to type in. Stopping these events in the capture
// phase at the search bar prevents the ancestor owc-select listener from ever running, so the search
// input keeps focus. Returns a ref callback to attach to the search bar element.
export const useSearchBarFocusGuard = () =>
    useCallback((element: HTMLElement | null) => {
        if (!element) {
            return;
        }
        const stopPropagation = (event: Event) => event.stopPropagation();
        (['pointerdown', 'mousedown', 'focusin'] as const).forEach((type) =>
            element.addEventListener(type, stopPropagation, true)
        );
    }, []);
